import { murmur3 } from "murmurhash-js";

import { ResponseError } from "@formant/core/common/ResponseError";

import { ErrorPageError } from "./ErrorPageError";

export class FeatureUnavailablePageError extends ErrorPageError {
    constructor(cause: ResponseError) {
        const hash = murmur3(`${cause.method} ${cause.url}`)
            .toString(16)
            .padStart(8, "0")
            .toUpperCase();

        const code = `${hash.substring(0, 4)}-${hash.substring(4)}`;

        super(
            cause,
            `This feature is not available, please re-authenticate your account to continue. Code: ${code}`,
        );
        this.name = "FeatureUnavailablePageError";
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
